module.exports = __webpack_public_path__ + "static/media/goodness_2.352f627e.jpg";